<template>
  <div class="payFeesDetails">
    <van-sticky>
      <div
        class="payFeesDetailsNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle">交易详情</span>
      </div>
    </van-sticky>
    <div class="content">
      <div class="tip" v-if="data.status == 10">
        订单剩余{{ countDown | dataFormatting }}自动关闭
      </div>
      <div class="card cardTop">
        <p>申请代理人费用</p>
        <h2>-{{ data.main_order ? data.main_order.total_amount : "" }}</h2>
        <span v-if="data.status == 10">待缴费</span>
        <span v-if="data.status == -10">交易取消</span>
        <span
          v-if="
            data.status == 20 &&
            data.contract &&
            data.contract.status >= 0 &&
            data.contract.status != 2
          "
          >已缴费，处理中</span
        >
        <span v-if="data.contract && data.contract.status == 2">交易成功</span>
        <span v-if="data.status == 40">交易失败，已退款</span>
        <span v-if="data.status == -40">退款失败</span>
      </div>
      <div class="card">
        <h3>缴费信息</h3>
        <p>
          订单编号：<span>{{ ordersn }}</span
          ><img
            @click="copy()"
            id="copycode"
            :data-clipboard-text="ordersn"
            src="./../../../assets/decoration/copy.png"
            alt=""
          />
        </p>
        <p>
          创建时间：<span>{{ data.created_at }}</span>
        </p>
        <p v-if="data.payed_at">
          支付时间：<span>{{ data.payed_at }}</span>
        </p>
        <p v-if="data.pay_type && data.city_agent && data.city_agent.type == 1">
          支付方式：
          <span v-if="data.pay_type == 1">银联支付</span>
          <span v-if="data.pay_type == 2">支付宝</span>
          <span v-if="data.pay_type == 3">微信</span>
          <span v-if="data.pay_type == 4">个人余额</span>
          <span v-if="data.pay_type == 5">支付宝H5</span>
          <span v-if="data.pay_type == 6">微信H5</span>
          <span v-if="data.pay_type == 15">小巴余额</span>
        </p>
        <div v-if="data.city_agent && data.city_agent.type == 2">
          <span>支付凭证：</span>
          <div>
            <img
              v-for="(item, i) in data.extra_pay_info.pay_voucher"
              :src="item"
              :key="i"
              alt=""
              @click="seeVoucher(data.extra_pay_info.pay_voucher, i)"
            />
          </div>
        </div>
      </div>
      <div v-if="data.status == 40">
        <div
          class="card"
          v-for="(item, index) in data.agent_refund"
          :key="index"
        >
          <h3>退款信息</h3>
          <p>
            订单编号：<span>{{ item.refund_sn }}</span
            ><img
              @click="copy()"
              id="copycode"
              :data-clipboard-text="item.refund_sn"
              src="./../../../assets/decoration/copy.png"
              alt=""
            />
          </p>
          <p>
            退款金额：<span>{{ item.refund_money }}</span>
          </p>
          <p>
            退款时间：<span>{{ item.finished_at }}</span>
          </p>
          <p>
            退款去向：
            <span v-if="item.refund_way == 1">原路退还</span>
            <span v-if="item.refund_way == 2">余额退还</span>
            <span v-if="item.refund_way == 3">线下打款</span>
            <span v-if="item.refund_way == 4">无支付退款</span>
            <span v-if="item.refund_way == 5">小巴余额</span>
          </p>
        </div>
      </div>

      <div
        class="contract"
        @click="seeContract(data.contract.contract_id)"
        v-if="data.contract && data.contract.status == 2"
      >
        <h3>
          <img
            src="./../../../assets/decoration/contractB.png"
            alt=""
          />查看合同
        </h3>
        <img src="./../../../assets/decoration/right.png" alt="" />
      </div>
      <div style="height: 95px"></div>
    </div>
    <div class="btm" v-if="data.status == 10">
      <div class="btn" @click="colseOrder()">关闭订单</div>
      <div class="btn" @click="topay()">去支付</div>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      isiOSX: false,
      ordersn: null,
      data: {},
      countDown: 0,
      isToken: false,
      order_sn: null,
    };
  },
  filters: {
    dataFormatting(value) {
      let val = Math.floor(value / 60) + "分" + Math.floor(value % 60) + "秒";
      return val;
    },
  },
  created() {
    this.isiOSX = this.isIphoneX();
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
      sessionStorage.setItem("token", JSON.stringify(this.$route.query.token));
      this.isToken = true;
    } else {
      this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
      this.isToken = false;
    }
    if (this.$route.query.order_sn) {
      this.order_sn = this.$route.query.order_sn;
    }
    this.getPayVoucher();
  },
  mounted() {
    window.setPay = this.setPay;
    window.decorationPayResult = this.decorationPayResult;
    window.decorateCancelPay = this.decorateCancelPay;
  },
  methods: {
    goBack() {
      if (this.isToken) {
        this.params("", "", "goBack");
      } else {
        this.$router.go(-1);
      }
    },
    // 判断是否是企业代理人
    getPayVoucher() {
      this.$api
        .post("decoration/member/agent/order/show", {
          order_sn: this.order_sn,
        })
        .then((res) => {
          if (res.city_agent.type == 1) {
            this.ordersn = res.order_sn;
            this.getData();
          } else {
            this.ordersn = res.order_sn_master;
            this.data = res;
          }
        });
    },
    getData() {
      this.$api
        .post("order/member/order/detail", {
          ordersn: this.ordersn,
          order: {
            type: "decoration",
          },
        })
        .then((res) => {
          // console.log(res);
          this.data = res;
          if (this.data.status == 10) {
            this.countDown = this.data.overdue_at;
            this.dateCountDown();
          }
        });
    },
    // 支付时间倒计时
    dateCountDown() {
      let dateDown = setInterval(() => {
        if (this.countDown > 0) {
          this.countDown = this.countDown - 1;
        } else {
          clearInterval(dateDown);
        }
      }, 1000);
    },
    colseOrder() {
      this.$dialog
        .confirm({
          title: "确认关闭订单？",
          message: "代理人申请将失败！",
          width: "280px",
          confirmButtonColor: "#5853E9",
          cancelButtonColor: "rgba(88, 83, 233, .1)",
          confirmButtonText: "我再想想",
          cancelButtonText: "关闭订单",
          theme: "round-button",
        })
        .then(() => {})
        .catch(() => {
          this.$api
            .post("decoration/index/order/active/cancel", {
              order_sn: this.ordersn,
              role: "CityAgent",
            })
            .then((res) => {
              this.$api
                .post("order/member/order/cancel", {
                  ordersn: this.ordersn,
                })
                .then((res) => {
                  this.$toast("成功关闭订单！");
                  this.getData();
                })
                .catch((err) => {
                  this.ThrowError(err);
                });
            })
            .catch((err) => {
              this.ThrowError(err);
            });
        });
    },
    topay() {
      let param = {
        actual_amount: this.data.main_order.actual_amount,
        order_amount: this.data.main_order.order_amount,
        ordersn: this.ordersn,
        order_type: "decoration_city_agent",
      };
      this.params(
        JSON.stringify(param),
        JSON.stringify(param),
        "decorationPay"
      );
    },
    // ios支付结果回调
    decorationPayResult() {
      this.setPay("success");
    },
    // 安卓支付结果回调
    setPay(res) {
      let result = false;
      if (res == "success") {
        result = true;
      } else {
        let data = JSON.parse(res);
        // console.log(data);
        if (data.code == 0) {
          result = true;
        } else if (data.code == -1) {
          result = false;
          this.decorateCancelPay();
        }
      }
      // this.params("", "1", "decorateBackOff");
      if (result) {
        this.$router.push({
          path: "/decoration/deputy/payResult",
          query: {
            ordersn: this.ordersn,
            result: result,
          },
        });
      }
    },
    decorateCancelPay() {
      this.$router.push({
        path: "/decoration/deputy/details",
      });
    },
    seeContract(contract_id) {
      this.$router.push({
        path: "/decoration/deputy/seeContract",
        query: {
          contract_id: contract_id,
        },
      });
    },
    copy() {
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$toast("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$toast("复制失败");
        // 释放内存
        clipboard.destroy();
      });
    },
    ThrowError(err) {
      let keys = Object.keys(err);
      let key = keys[0];
      let message = err.message || err[key][0];
      if (message.slice(0, 10) == "timeout of") {
        this.$toast("网络不给力，请稍候重试");
      } else {
        this.$toast(message);
      }
      return;
    },
    // 查看凭证
    seeVoucher(images, startPosition) {
      ImagePreview({
        images: images,
        startPosition: startPosition,
      });
    },
  },
};
</script>
<style lang="less">
.payFeesDetails {
  height: 100%;
  background: #f5f6ff;
  .payFeesDetailsNav {
    background: #ffffff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
  }
  .content {
    background: #f5f6ff;
    .tip {
      background-color: rgba(255, 219, 198, 0.9);
      height: 40px;
      line-height: 40px;
      padding: 0 16px;
      font-size: 14px;
      color: #ff7e31;
    }
    .card {
      background: #ffffff;
      border-radius: 12px;
      margin: 12px 16px 0;
      display: flex;
      flex-direction: column;
      padding: 24px;
      p {
        font-size: 15px;
        color: #999999;
        line-height: 21px;
        display: flex;
        align-items: center;
        margin-top: 16px;
        span {
          color: #333333;
        }
        img {
          width: 16px;
          height: 16px;
          margin-left: 6px;
        }
      }
      h3 {
        font-size: 15px;
        font-weight: 600;
        color: #333333;
        line-height: 21px;
        margin: 0 0 4px;
      }
      > div {
        font-size: 15px;
        color: #999999;
        line-height: 21px;
        display: flex;
        margin-top: 16px;
        span {
          flex-shrink: 0;
        }
        div {
          display: flex;
          flex-wrap: wrap;
          img {
            width: 56px;
            height: 56px;
            border-radius: 4px;
            border: 1px solid #cacde0;
            margin-right: 4px;
          }
        }
      }
    }
    .cardTop {
      align-items: center;
      p {
        font-size: 14px;
        color: #999999;
        line-height: 20px;
        margin: 0;
      }
      h2 {
        font-size: 24px;
        font-weight: 600;
        color: #333333;
        line-height: 33px;
        margin: 16px 0;
      }
      span {
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        margin-bottom: 11px;
      }
    }
    .contract {
      background: #ffffff;
      border-radius: 12px;
      margin: 12px 16px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 24px;
      h3 {
        font-size: 15px;
        font-weight: 600;
        color: #333333;
        line-height: 21px;
        margin: 0px;
        display: flex;
        align-items: center;
        img {
          width: 20px;
          height: 20px;
          margin-right: 4px;
        }
      }
      img {
        width: 12px;
        height: 12px;
      }
    }
  }
  .btm {
    width: 100%;
    height: 83px;
    background-color: #ffffff;
    position: fixed;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: flex-end;
    .btn {
      margin: 6px 16px 0 0;
      padding: 9px 21px;
      border-radius: 25px;
      border: 1px solid #cccccc;
      height: 21px;
      line-height: 21px;
      font-size: 15px;
      color: #333333;
    }
  }
}
.van-dialog__confirm,
.van-dialog__cancel {
  margin: 0 8px;
  border-radius: 18px;
}
.van-dialog__cancel {
  color: #5853e9 !important;
}
</style>